export const AmazonShipmentFilterValues = Object.freeze({
    ALL: 'all',
    ONLY_WITH_ASINS: 'onlyWithAsins',
    ONLY_WITHOUT_ASINS: 'onlyWithoutAsins',
})

export const AddToAmazonShipmentField = Object.freeze({
    FIELD_NAME: 'addToAmazonShipment',
    FILTER_NAME: 'addToAmazonShipmentFilter',
})